import React, { memo, useEffect, useRef } from "react";
import { connectHits, connectSearchBox, connectStateResults } from "react-instantsearch-dom";
import { withAuth } from "@muchbetteradventures/signup-form-lib";
import { GlobalSearchDrawer } from "@muchbetteradventures/styleguide";
import SearchBox, { getPersistedRefinement } from "./SearchBox";
import Hits from "./Hits";
import { useFx } from "../../hooks";
var ConnectedHits = connectHits(connectStateResults(Hits));
var ConnectedSearchBox = connectSearchBox(SearchBox);

var SearchDrawer = function SearchDrawer(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      trackEvent = _ref.trackEvent;
  var inputRef = useRef(null);
  useEffect(function () {
    if (open && inputRef.current) {
      inputRef.current.focus();
    }
  }, [open]);
  var defaultRefinement = getPersistedRefinement();
  var renderPrice = useFx();
  return /*#__PURE__*/React.createElement(GlobalSearchDrawer, {
    offsetTopBelowMenuBar: true,
    open: open,
    onClose: onClose,
    searchInput: /*#__PURE__*/React.createElement(ConnectedSearchBox, {
      defaultRefinement: defaultRefinement,
      onClose: onClose,
      inputRef: inputRef
    }),
    searchResults: /*#__PURE__*/React.createElement(ConnectedHits, {
      renderPrice: renderPrice,
      trackEvent: trackEvent
    })
  });
};

var SearchDrawerAuthed = withAuth(SearchDrawer);
var SearchDrawerAuthedMemo = /*#__PURE__*/memo(withAuth(SearchDrawer));
export { SearchDrawer, SearchDrawerAuthed, SearchDrawerAuthedMemo };